module.exports = __webpack_public_path__ + "static/media/bb-logo-blue-name.f153d778.png";